import React, { Fragment } from 'react';
import { H4, H6, P, UL } from '../../../AbstractElements';
import { useTranslation } from 'react-i18next';

const FormHeader = (props) => {
    const { t } = useTranslation();
    const { selected = '' } = props;
    return (
        <Fragment>
            <div>
                <H4>{t("Sign In To NADA Admin Portal")}</H4>
                <H6>{t("Welcome back! Log in to your account.")}</H6>
            </div>
        </Fragment>
    );
};
export default FormHeader;
